import type { StatusMeta } from '../../services/workQueue';
import {
    IMPLEMENTED_PHASES,
    IMPLEMENTED_STATUSES,
    ARCHIVED_STATUS_ID,
    AUTOMATION_ONLY_STATUS_IDS,
    DESIGN_EXPIRED_STATUS_ID
} from './constants.ts';

// Excluded: deprecated, holds (Put-on-hold captures resume context), archived and
// expired (their own actions only), and the automation-owned VA steps.
function isForceTarget(s: StatusMeta): boolean {
    return (
        !s.deprecated &&
        s.macro !== 'hold' &&
        s.id !== ARCHIVED_STATUS_ID &&
        s.id !== DESIGN_EXPIRED_STATUS_ID &&
        !AUTOMATION_ONLY_STATUS_IDS.has(s.id) &&
        (IMPLEMENTED_PHASES.has(s.phase) || IMPLEMENTED_STATUSES.has(s.id))
    );
}

export function forceStatusTargetsByPhase(
    statuses: readonly StatusMeta[]
): Record<string, StatusMeta[]> {
    return statuses
        .filter(isForceTarget)
        .reduce<Record<string, StatusMeta[]>>(
            (acc, s) => ({ ...acc, [s.phase]: [...(acc[s.phase] ?? []), s] }),
            {}
        );
}
